import React, { MutableRefObject, useEffect } from "react";
import { Expo } from "gsap/all";
import { motion } from "framer-motion";
import img from "../../images/bg-2.jpg"
import anime from "animejs";
import { animateSingleProjectModal } from "../../pages/Home/helperAnimations";
function SingleProjectModal() {

    // const letterRef = React.useRef() as MutableRefObject<HTMLDivElement>;
 
 
    useEffect(() => {
    //   tweenAnimationSequence();
    //   const bgMain = (letterRef as MutableRefObject<HTMLDivElement>).current;
    //   if (typeof bgMain.textContent === "string") {
    //     // eslint-disable-next-line no-control-regex
    //     bgMain.innerHTML =
    //       bgMain.textContent &&
    //       bgMain.textContent.replace(
    //         /\S/g,
    //         "<span class='letter'>$&</span>"
    //       );
    //       anime.timeline().add({
    //         targets: ".title .letter",
    //         translateY: [100, 0],
    //         translateZ: 0,
    //         opacity: [0, 1],
    //         easing: "easeOutExpo",
    //         duration: 2000,
    //         delay: (el, i) => 4800 + 40 * i,
    //       });
    //   }
      animateSingleProjectModal()
    }, []);
  return (
    <motion.div
      className="singleProjectContainer"
      style={{ zIndex: "999" }}
      animate={{
        y: "20%",
        opacity: 1,
        animationDuration: "0.5",
        transition: { duration: 2, ease: Expo.easeInOut },
      }}
      initial={{ y: "-100%", opacity: 0, transitionDelay: "0.5" }}
      exit={{
        y: "-100%",
        opacity: 0,
        transition: { duration: 1.5, stiffness: 10, ease: Expo.easeInOut },
      }}
      // transition={{ type: "spring",   duration: 5 ,delay: 3}}
      // variants={postVariants}
    >
      <div className="project_modal_container">
        <div className="images">
          <div className="left img"></div>
          <div className="right img"></div>
        </div>
        <div className="hero-image">
          <div className="wrapper-img">
            <div className="box"></div>
            <div>
              <img className="image" alt="images" src={img} />
            </div>
          </div>
        </div>
        {/* <div className="header">
          <p className="title" ref={letterRef}>antidote</p>
        </div> */}
        <div className="hero-container">
          <div className="sidebar-text">
            <span>TITLE</span><br></br>
            <span>Lorem ipsum dolor sit amet.</span>
          </div>
          {/* <div className="projects">projects</div> */}
          {/* <div class="img-nav">
          <div class="prev">prev</div>
          <div class="next">next</div>
        </div> */}
        </div>
      </div>
    </motion.div>
  );
}

export default SingleProjectModal;
